export default {
    about_doctor: "Про лікаря",
    account_manager: "Аккаунт менеджер",
    activated: "активовано",
    additional_info: "Додаткова інформація",
    administrator: "Адміністратор",
    administrators: "Адміністратори",
    amount_of_doctors: "Кількість лікарів",
    are_you_sure_you_want_to_delete_field: "Ви впевнені, що хочете видалити напрямок",
    assistants: "Асистенти",
    backup_code: "Резервний код",
    block: "Заблокувати",
    block_noun: "Блок",
    browse_computer: "Вибрати з файлів",
    by_cabinets: "По офісу",
    by_days: "По днях",
    by_days_of_week: "По днях тижня",
    by_even_days: "По парних днях",
    by_odd_days: "По непарних днях",
    cabinet: "Кабінет",
    cabinets: "Шафи",
    chair: "Крісло",
    chairs: "Крісла",
    clinic_access_request: "Запит доступу до клініки",
    config: "Конфігурація",
    confirm_password: "Повторити пароль",
    curator: "Куратор",
    curators: "Куратори",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Технічна підтримка Dentist+ запитує доступ до вашої клініки",
    doctor_position: "Посада лікаря",
    doctor_specialty: "Спеціальність лікаря",
    enter_backup_code_note: "Введіть один із резервних кодів, які ви отримали під час активації двофакторної автентифікації. Зверніть увагу, що кожен резервний код можна використати лише один раз",
    enter_code_from_authorization_app: "Введіть код із програми двофакторної автентифікації на вашому телефоні",
    field: "Напрямок",
    fields: "Напрямки",
    functionality: "Функціонал",
    login_and_password: "Логін і пароль",
    manual_pay_system: "Ручна платіжна система",
    not_worked: "Не відпрацьовано",
    partner: "Партнер",
    password_does_not_match_confirmation: "Пароль не співпадає з підтвердженням",
    password_requirement_min_length: "Не менше {min} символів",
    password_requirement_mixed_case: "Латинські літери у верхньому та нижньому регістрі",
    password_requirement_number: "Обов'язково цифра",
    password_requirement_symbol: "Обов'язково спецсимвол",
    percent: "Відсоток",
    period_from: "Період з",
    period_to: "Період до",
    phone2: "Телефон 2",
    profession: "Спеціальність",
    rate: "Ставка",
    rate_per_day: "Ставка на день",
    rate_per_hour: "Ставка за годину",
    rate_per_month: "Ставка на місяць",
    reserve_codes: "Коди резерву",
    roles: "Ролі",
    sale_good_percent: "Відсоток від реалізації товару",
    schedule_conflicts_found: "Знайдено конфліктів розкладу з поточними записами",
    seller: "Продавець",
    staff: "Персонал",
    take_photo: "Зробити фото",
    technics: "Техніки",
    turn_on: "Увімкніть",
    turned_off: "Вимкнено",
    two_factor_authorization: "Двофакторна аутентифікація",
    two_factor_authorization_setup_successfully: "Двофакторну автентифікацію успішно активовано",
    twofactor_setup_instructions: "<ul><li>Завантажте програму автентифікації (наприклад, Google Authenticator, Microsoft Authenticator, Yandex.Key) з App Store або Google Play.</li><li>Натисніть «Додати код»/«+» у програмі на своєму телефоні та відскануйте QR-код, який відображається на екрані комп’ютера.</li><li>Введіть 6-значний код, згенерований програмою, у відповідне поле під QR-кодом, щоб завершити. прив’язки</li><li>Обов’язково збережіть запропоновані резервні коди (з’являться після перевірки 6-значного коду) у безпечному місці на випадок, якщо ви загубите свій телефон</li></ul>",
    use_app_code: "Використовуйте стандартний код",
    use_backup_code: "Використовуйте резервний код",
    user_data: "Дані користувача",
    user_will_assigned_rights_selected_for_that_role: "Користувачу будуть призначені права, вибрані для цієї ролі",
    weekend: "Вихідний",
    without_warehouse_form_note: "Без прив'язки до складу, матеріали будуть зписуватися з основного складу або зі складу, прив'язаного до кресла",
    work_day: "Робочий день",
    work_days: "Робочі дні",
    work_schedule: "Графік роботи",
    work_time: "Робочий час",
    worked: "Відпрацьовано"
}
